export default __webpack_public_path__ + "static/media/background-circles.cd1f22d7.svg";